import React from 'react';
import PropTypes from 'prop-types';
import { getLogoFromTheme } from '../utils/LoginUtils';

const LoginLogo = (props) => {
    const {
        contextCls,
        theme,
        logoAltText = 'Logo',
        legacyLoginConfig,
    } = props;

    const logoImageURL = getLogoFromTheme(theme);

    if (!logoImageURL) {
        return false;
    }

    const { context = '' } = legacyLoginConfig ?? {};
    const logoLink = `${context}/app/home`;

    return (
        <div className={contextCls}>
            <a href={logoLink}>
                <img src={logoImageURL} alt={logoAltText} />
            </a>
        </div>
    );
};

LoginLogo.defaultProps = {};

LoginLogo.propTypes = {
    contextCls: PropTypes.string,
    theme: PropTypes.object,
    legacyLoginConfig: PropTypes.object,
    logoAltText: PropTypes.string,
};

export default LoginLogo;
